import ticket from "lottiefiles/ticket.json"
import qrcode from "lottiefiles/qrcode.json"
import seats from "lottiefiles/seats.json"
import data_analysis from "lottiefiles/data_analysis.json"
import user from "lottiefiles/user.json"
import stats from "lottiefiles/stats.json"

export interface PassTicketsFeatures {
    service: string
    media: any
    description: string
}

export const PassTicketsFeatures: Array<PassTicketsFeatures> = [
    {
        service: "مرونة في تخصيص التذاكر",
        // media: "/images/ticket-coupon-1.png",
        media: ticket,
        description:
            "خيارات تلبي رغباتكم، تصميمها، خصائصها، كلها تنطلق من احتياجاتكم.",
    },
    {
        service: " نظام مسح ضوئي متقدم",
        media: qrcode,
        description:
            "نظام مبتكر في مسح التذاكر تم تطويره بشكل عملي  ليعمل بكل سهولة ويسر.",
    },
    {
        service: "خريطة جلوس واقعية",
        media: seats,
        description: "خرائط عالية الجودة تعكس منطقة الجلوس الحقيقية في المكان",
    },
    {
        service: "لوحة تحكم رئيسية متطورة",
        media: stats,
        description:
            "تناسب جميع أنواع الفعاليات والأنشطة تتطور باستمرار لتوفير تـجربـة سلسـة",
    },
    {
        service: "فريق عمل مدرب",
        media: user,
        description:
            "متدربين على أعلى المستويات، ملمين بأدق تفاصيل تنظيم الفعاليات.",
    },
    {
        service: "تقارير دورية",
        media: data_analysis,
        description: "نضمن لكم معها السيطرة الكاملة والمتابعة الدقيقة ",
    },
]
